
// import {
//   Card,
//   Grid,
//   Stack,
//   useTheme,
// } from "@mui/material";
// import React, { useContext, useEffect, useState } from "react";

// import { CurtailmentDataApi } from "../../../../../api/Api";
// import { AppThemeContext } from "../../../../../context/AppThemeContext";
// import { AuthenticationContext } from "../../../../../context/AuthenticationContext";

// import ExportExcel from "../../../../../components/exportExcel/ExportExcel1";
// import ExportPdf from "../../../../../components/exportPdf/ExportPdf";

// import { PASS_KEY, WEB_KEY, BaseUrl } from "../../../../../api/AxiosApi";
// import logo from "../../../../../assets/img/logos/logo 2.png";

// import "./CurtailmentData.css";

// /* ================= DATE HELPERS ================= */

// // ✅ Today
// export function getTodayDate(date = new Date()) {
//   return date.toISOString().split("T")[0]; // YYYY-MM-DD
// }

// // ✅ Yesterday (DEFAULT)
// export function getYesterdayDate(date = new Date()) {
//   const yesterday = new Date(date);
//   yesterday.setDate(yesterday.getDate() - 1);
//   return yesterday.toISOString().split("T")[0];
// }

// // ✅ API expects DD-MMM-YYYY
// function formatDateForApi(dateStr) {
//   const date = new Date(dateStr);
//   const day = String(date.getDate()).padStart(2, "0");
//   const month = date
//     .toLocaleString("en-US", { month: "short" })
//     .toUpperCase();
//   const year = date.getFullYear();
//   return `${day}-${month}-${year}`;
// }

// /* ================= COMPONENT ================= */

// function CurtailmentData() {
//   const { LoggedInUserInfo } = useContext(AuthenticationContext);
//   const { PrimaryColor } = useContext(AppThemeContext);
//   const { spacing } = useTheme();

//   // 🔥 DEFAULT DATE = YESTERDAY
//   const [selectedDate, setSelectedDate] = useState(getYesterdayDate());

//   const [logData, setLogData] = useState([]);
//   const [loading, setLoading] = useState(false);

//   /* ================= PAGINATION ================= */
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 25;

//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentData = logData.slice(indexOfFirstItem, indexOfLastItem);

//   /* ================= API ================= */

//   const credentials = {
//     LOGIN_ID: sessionStorage.getItem("LoginID") || "",
//     PASS_KEY: sessionStorage.getItem("PASS_KEY") || "xyz",
//     LCODE: sessionStorage.getItem("LCODE") || "",
//     WEB_KEY: "xyz",
//     DT1: formatDateForApi(selectedDate),
//     DT2: formatDateForApi(selectedDate),
//   };

//   const fetchLogData = async () => {
//     setLoading(true);
//     setLogData([]);

//     try {
//       console.log("API PARAMS:", credentials);
//       const res = await CurtailmentDataApi(credentials);

//       if (res?.DAILY_CURT && Array.isArray(res.DAILY_CURT)) {
//         setLogData(res.DAILY_CURT);
//         setCurrentPage(1);
//       } else {
//         setLogData([]);
//       }
//     } catch (error) {
//       console.error("Fetch Error:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // 🔥 AUTO LOAD (YESTERDAY DATA)
//   useEffect(() => {
//     fetchLogData();
//   }, []);

//   /* ================= EXPORT ================= */

//   const ImageUrl = `${BaseUrl}CMN_02/GET_COM_LOGO?LOGIN_ID=${credentials.LOGIN_ID}&LOC_CODE=${credentials.LCODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}`;

//   const tableHeaders =
//     logData.length > 0 ? Object.keys(logData[0]) : [];

//   const exportToExcel = async () => {
//     await ExportExcel(
//       ImageUrl,
//       logData,
//       selectedDate,
//       selectedDate,
//       "Day Wise Curtailment",
//       LoggedInUserInfo
//     );
//   };

//   const exportToPDF = async () => {
//     await ExportPdf(
//       ImageUrl,
//       currentData,
//       selectedDate,
//       selectedDate,
//       "Day Wise Curtailment",
//       LoggedInUserInfo,
//       logo,
//       tableHeaders
//     );
//   };

//   /* ================= RENDER ================= */

//   return (
//     <Grid container>
//       <Grid item xs={12}>
//         <Stack mt={1}>
//           <Card sx={{ p: spacing(1) }}>

//             {/* HEADER */}
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 marginBottom: "8px",
//               }}
//             >
//               <div style={{ fontSize: "14px" }}>
//                 <b>Day Wise Curtailment</b>
//               </div>

//               <div style={{ display: "flex", gap: "10px" }}>
                
//                 {/* ✅ DATE PICKER */}
//                 <label>
//                   Date&nbsp;:&nbsp;
//                   <input
//                     type="date"
//                     value={selectedDate}
//                     max={getTodayDate()}   // ✅ TODAY ALLOWED
//                     onChange={(e) =>
//                       setSelectedDate(e.target.value)
//                     }
//                   />
//                 </label>

//                 <button
//                   className="button-style"
//                   onClick={fetchLogData}
//                 >
//                   Show
//                 </button>

//                 <button
//                   className="export-button"
//                   onClick={exportToExcel}
//                 >
//                   Excel
//                 </button>

//                 <button
//                   className="export-button2"
//                   onClick={exportToPDF}
//                 >
//                   PDF
//                 </button>
//               </div>
//             </div>

//             {/* TABLE */}
//             <div className="table-responsive">
//               <table className="table table-bordered table-hover">
//                 <thead
//                   className="text-center"
//                   style={{ backgroundColor: "#fdf8e4" }}
//                 >
//                   <tr>
//                     {tableHeaders.map((h, i) => (
//                       <th key={i} style={{ color: PrimaryColor }}>
//                         {h}
//                       </th>
//                     ))}
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {loading ? (
//                     <tr>
//                       <td colSpan={tableHeaders.length} className="text-center">
//                         Loading...
//                       </td>
//                     </tr>
//                   ) : currentData.length > 0 ? (
//                     currentData.map((row, i) => (
//                       <tr key={i}>
//                         {tableHeaders.map((key, idx) => (
//                           <td key={idx} className="text-center">
//                             {row[key] ?? ""}
//                           </td>
//                         ))}
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td colSpan={tableHeaders.length} className="text-center">
//                         No curtailment data for selected date
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>

//           </Card>
//         </Stack>
//       </Grid>
//     </Grid>
//   );
// }

// export default CurtailmentData;

import {
  Card,
  Grid,
  Stack,
  useTheme,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";

import { CurtailmentDataApi } from "../../../../../api/Api";
import { AppThemeContext } from "../../../../../context/AppThemeContext";
import { AuthenticationContext } from "../../../../../context/AuthenticationContext";

import ExportExcel from "../../../../../components/exportExcel/ExportExcel1";
import ExportPdf from "../../../../../components/exportPdf/ExportPdf";

import { PASS_KEY, WEB_KEY, BaseUrl } from "../../../../../api/AxiosApi";
import logo from "../../../../../assets/img/logos/logo 2.png";

import "./CurtailmentData.css";

/* ================= DATE HELPERS ================= */

// ✅ Today
export function getTodayDate(date = new Date()) {
  return date.toISOString().split("T")[0];
}

// ✅ Yesterday (DEFAULT)
export function getYesterdayDate(date = new Date()) {
  const yesterday = new Date(date);
  yesterday.setDate(yesterday.getDate() - 1);
  return yesterday.toISOString().split("T")[0];
}

// ✅ API expects DD-MMM-YYYY
function formatDateForApi(dateStr) {
  const date = new Date(dateStr);
  const day = String(date.getDate()).padStart(2, "0");
  const month = date
    .toLocaleString("en-US", { month: "short" })
    .toUpperCase();
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
}

/* ================= COMPONENT ================= */

function CurtailmentData() {
  const { LoggedInUserInfo } = useContext(AuthenticationContext);
  const { PrimaryColor } = useContext(AppThemeContext);
  const { spacing } = useTheme();

  // 🔥 DEFAULT DATE = YESTERDAY
  const [selectedDate, setSelectedDate] = useState(getYesterdayDate());
  const [logData, setLogData] = useState([]);
  const [loading, setLoading] = useState(false);

  /* ================= API ================= */

  const credentials = {
    LOGIN_ID: sessionStorage.getItem("LoginID") || "",
    PASS_KEY: sessionStorage.getItem("PASS_KEY") || "xyz",
    LCODE: sessionStorage.getItem("LCODE") || "",
    WEB_KEY: "xyz",
    DT1: formatDateForApi(selectedDate),
    DT2: formatDateForApi(selectedDate),
  };

  const fetchLogData = async () => {
    setLoading(true);
    setLogData([]);

    try {
      const res = await CurtailmentDataApi(credentials);

      if (res?.DAILY_CURT && Array.isArray(res.DAILY_CURT)) {
        setLogData(res.DAILY_CURT);
      } else {
        setLogData([]);
      }
    } catch (error) {
      console.error("Fetch Error:", error);
      setLogData([]);
    } finally {
      setLoading(false);
    }
  };

  // 🔥 AUTO LOAD (YESTERDAY DATA)
  useEffect(() => {
    fetchLogData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* ================= EXPORT ================= */

  const ImageUrl = `${BaseUrl}CMN_02/GET_COM_LOGO?LOGIN_ID=${credentials.LOGIN_ID}&LOC_CODE=${credentials.LCODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}`;

  const tableHeaders =
    logData.length > 0 ? Object.keys(logData[0]) : [];

  const exportToExcel = async () => {
    await ExportExcel(
      ImageUrl,
      logData,
      selectedDate,
      selectedDate,
      "Day Wise Curtailment",
      LoggedInUserInfo
    );
  };

  const exportToPDF = async () => {
    await ExportPdf(
      ImageUrl,
      logData, // ✅ FULL DATA
      selectedDate,
      selectedDate,
      "Day Wise Curtailment",
      LoggedInUserInfo,
      logo,
      tableHeaders
    );
  };

  /* ================= RENDER ================= */

  return (
    <Grid container>
      <Grid item xs={12}>
        <Stack mt={1}>
          <Card sx={{ p: spacing(1) }}>

            {/* HEADER */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "8px",
              }}
            >
              <div style={{ fontSize: "14px" }}>
                <b>Day Wise Curtailment</b>
              </div>

              <div style={{ display: "flex", gap: "10px" }}>
                {/* DATE PICKER */}
                <label>
                  Date&nbsp;:&nbsp;
                  <input
                    type="date"
                    value={selectedDate}
                    max={getTodayDate()}
                    onChange={(e) =>
                      setSelectedDate(e.target.value)
                    }
                  />
                </label>

                <button
                  className="button-style"
                  onClick={fetchLogData}
                >
                  Show
                </button>

                <button
                  className="export-button"
                  onClick={exportToExcel}
                >
                  Excel
                </button>

                <button
                  className="export-button2"
                  onClick={exportToPDF}
                >
                  PDF
                </button>
              </div>
            </div>

            {/* TABLE */}
            <div className="table-responsive">
              <table className="table table-bordered table-hover">
                <thead
                  className="text-center"
                  style={{ backgroundColor: "#fdf8e4" }}
                >
                  <tr>
                    {tableHeaders.map((h, i) => (
                      <th key={i} style={{ color: PrimaryColor }}>
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {loading ? (
                    <tr>
                      <td
                        colSpan={tableHeaders.length}
                        className="text-center"
                      >
                        Loading...
                      </td>
                    </tr>
                  ) : logData.length > 0 ? (
                    logData.map((row, i) => (
                      <tr key={i}>
                        {tableHeaders.map((key, idx) => (
                          <td key={idx} className="text-center">
                            {row[key] ?? ""}
                          </td>
                        ))}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={tableHeaders.length}
                        className="text-center"
                      >
                        No curtailment data for selected date
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

          </Card>
        </Stack>
      </Grid>
    </Grid>
  );
}

export default CurtailmentData;